// extracted by css-extract-rspack-plugin
export default {"root":"root-BhTcZT","text":"text-B1FbFr text-sm"};